export const upload = {
  start: {
    credentialsErrorMessage: 'Please double check your credentials',
    unknownErrorMessage: 'An unknown error has occurred. Please contact support',
    genericErrorMessage: 'Something has gone wrong.  Please make sure you enter your details correctly',
    lastNameLabel: 'Last Name',
    dateOfBirthLabel: 'Date of Birth',
    submitLabel: 'Submit'
  },
  thanks: {
    title: 'Thank you',
    description: 'You can now close this tab/window'
  },
  insurance: {
    takePhotoLabel: 'Take Photo',
    invalidSessionMessage: 'Invalid Session',
    genericErrorMessage: 'Something has gone wrong',
    imageName: 'Insurance Card Image',
    saveFailedMessage: 'Failed to save record.',
    frontSideLabel: 'Front Side',
    backSideLabel: 'Back Side'
  },
  combinePdf: {
    uploadFailedMessage: 'Upload failed',
    title: 'Upload Images'
  },
  medications: {
    invalidSessionMessage: 'Invalid Session',
    genericErrorMessage: 'Something has gone wrong',
    successTitle: 'Upload Successful'
  },
  quickUpload: {
    invalidSessionMessage: 'Invalid quick upload session',
    routeNotFoundMessage: 'Route not found'
  }
} as const;
